module.exports = __webpack_public_path__ + "img/courses.c35ff43b.svg";